import axios from "./axios";

export default class MsiService {
    static getMsiProfile(code) {
        return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual', { code }, {
            withCredentials: true
        });
    }
    static getRegistrationContext() {
        return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/registration/context', {}, {
            withCredentials: true,
        });
    }
    static signUp(payload, proof) {
        return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/registration', payload, {
            withCredentials: true,
            headers: {
                'x-client-context': proof,
            },
        });
    }
    // static signUp(payload) {
    //     return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/registration', payload, {
    //         withCredentials: true
    //     });
    // }
    static sendRecoveryPasswordOtp(login) {
        return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/recovery/start', {
            login,
            purpose: 'password-change'
        });
    }
    static verifyRecoveryPasswordOtp(payload) {
        return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/recovery/verify', payload);
    }
    static setNewPassword(payload) {
        return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/recovery/finish', payload);
    }
    static recoveryCheckIdNumber(payload) {
        return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/recovery/check', payload);
    }
    static changePassword(payload) {
        return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/change-password', payload);
    }
}